import { render, staticRenderFns } from "./user-avatar.vue?vue&type=template&id=bf109888&scoped=true&"
import script from "./user-avatar.vue?vue&type=script&lang=ts&"
export * from "./user-avatar.vue?vue&type=script&lang=ts&"
import style0 from "./user-avatar.vue?vue&type=style&index=0&id=bf109888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf109888",
  null
  
)

export default component.exports